import './ccf-call-conference-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfCallConferenceIconProps extends SvgIconProps  {}

/**
 * Component displays call  consference  svg icon 
 * @param props -CcfCallConferenceIconProps
 * @returns consference svg icon
 * @example - <CcfCallConferenceIcon/>
 */
export function CcfCallConferenceIcon(props: CcfCallConferenceIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Conference" data-name="Conference">
        <rect width="20" height="20" fill="none" />
        <g id="Group_119239" data-name="Group 119239">
          <ellipse
            id="Ellipse_126"
            data-name="Ellipse 126"
            cx="3.043"
            cy="3.182"
            rx="3.043"
            ry="3.182"
            transform="translate(6.957)"
          />
          <ellipse
            id="Ellipse_127"
            data-name="Ellipse 127"
            cx="3.043"
            cy="3.182"
            rx="3.043"
            ry="3.182"
            transform="translate(0 11.818)"
          />
          <ellipse
            id="Ellipse_128"
            data-name="Ellipse 128"
            cx="3.043"
            cy="3.182"
            rx="3.043"
            ry="3.182"
            transform="translate(13.913 11.818)"
          />
          <line
            id="Line_1"
            data-name="Line 1"
            x2="6.957"
            y2="11.406"
            transform="translate(10 3.594)"
            fill="none"
            stroke="currentcolor"
            strokeWidth="2"
          />
          <path
            id="Path_13057"
            data-name="Path 13057"
            d="M-.259-.215H14.523"
            transform="translate(3.303 15.215)"
            fill="none"
            stroke="currentcolor"
            strokeWidth="2"
          />
          <line
            id="Line_3"
            data-name="Line 3"
            x1="6.087"
            y2="10.496"
            transform="translate(3.392 3.594)"
            fill="none"
            stroke="currentcolor"
            strokeWidth="2"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfCallConferenceIcon;
